// extracted by mini-css-extract-plugin
export default {"form-items-row":"styles_form-items-row__E3gq5","form-item":"styles_form-item__9M8xm","form-item-right":"styles_form-item-right__hxAYA","badge":"styles_badge__93KjM"};